export default {
  COMPANIES: {
    TITLE: 'Company',
    EDIT_TITLE: 'Company data',
    CREATE: {
      STEP_1: {
        HELLO: 'Hi {{ username }}, ',
        TITLE_CREATE: 'let\'s set up your company',
        SUBTITLE: 'Company info',
        TITLE_EDIT: 'Update company details',
        INFORMATION: 'Enter your address and select a match',
        COUNTRY: 'Country',
        CIF: {
          DEFAULT: 'Tax ID',
          ES: 'NIF',
          MX: 'RFC',
          US: 'EIN',
          UK: 'VAT',
          CA: 'BN',
          GB: 'VAT',
          FR: 'SIRET',
          IT: 'P.IVA',
          IE: 'VAT',
          DE: 'USt-IdNr',
          CO: 'NIT',
          AR: 'CUIT',
          CL: 'RUT',
          PE: 'RUC',
          GT: 'NIT',
          EC: 'RUC',
          SV: 'NIT',
          CR: 'Cédula Jurídica',
          DO: 'RNC',
          VE: 'RIF',
          BR: 'CNPJ',
        },
        NAME: 'Legal name',
        BUSINESS_NAME: 'Company name',
        ADDRESS: 'Please select an address from the dropdown',
        ADDRESS_PLACEHOLDER: 'Enter company address',
        CITY: 'City',
        POSTAL_CODE: 'ZIP / Postal code',
        STATE: 'State / Province',
        LOCATION_AUTO_PLACEHOLDER: 'Auto-filled based on address',
        LOCATION_MANUAL_PLACEHOLDER: 'Complete this field',
        LOCATION_OPTIONAL_PLACEHOLDER: 'Optional field',
        LOCATION_STATE_NOT_DETECTED_ERROR: 'Select a more precise address so this field can be auto-filled.',
        WEB: 'Website or social profile',
        NO_WEB: 'Company doesn\'t have a website.',
        SECTOR: 'Industry',
        SIZE: 'Company size',
        LINKEDIN: 'LinkedIn profile',
        LINKEDIN_HELP: 'e.g., https://linkedin.com/company/wokap',
        LOCATIONS: 'Locations',
        ADD_LOCATION: 'Add location',
        NO_LINKEDIN: 'Company doesn\'t have a LinkedIn profile.',
        TAGS_HELP: 'Press Enter or Comma to add a tag.',
        PLACEHOLDER: {
          NAME: 'Enter legal name',
          BUSINESS_NAME: 'Enter company name',
          WEB: 'Enter website URL',
          LINKEDIN: 'Enter LinkedIn profile URL',
          CIF: 'Enter tax ID',
          SECTOR: 'Select an industry',
          SIZE: 'Select company size',
        },
        DIALOG: {
          HEADER: 'Cancel setup',
          MESSAGE: 'Are you sure you want to cancel? Your progress will be lost.',
          ACCEPT: 'Continue',
          REJECT: 'Go back',
        },
      },
      STEP_2: {
        TITLE: 'Invite team members to manage your company account.',
        ADD_RESPONSIBLE: 'Add team member',
        RESPONSIBLE_NUMBER: 'Admin',
        INVITE_PERMISSIONS_INFO_1: 'You can add team members now or do it later, once the company has been registered, from “User Management”.',
        INVITE_PERMISSIONS_INFO_2: 'Keep in mind that, if you add team members now, everyone you add will have access to all offers and branches.',
        INVITE_PERMISSIONS_INFO_3: 'Once the company has been registered, you\'ll be able to modify, restrict or assign specific permissions to each person from “User Management”.',
        PERMISSION_INFO_DESCRIPTION_1: 'This table shows the actions each user can perform based on the different roles available. Choose which one to assign to the people who will help you manage your company account.',
        SAVE_CARD: 'Save',
        SAVE_CARD_LABEL: 'Saved',
        SAVE_ALL_BEFORE_CONTINUE: 'There\'s an unsaved user.<br class="block sm:hidden"> Remove it or save it to continue.',
        MAX_RESPONSIBLES_REACHED: 'You can invite up to three people during registration. Once the company is created, you can manage and add as many users as you need in User Management.',
        AUTHORIZED_PERSON: {
          FIRSTNAME: 'First name',
          LASTNAME: 'Last name',
          COMPANY_POSITION: 'Job title',
          EMAIL: 'Email address',
          PHONE: 'Phone number',
          CONTACT_PHONE: 'Contact number',
          PHONE_HELP: 'e.g., +12345678900',
          GROUP: { LABEL: 'Role' },
        },
        PLACEHOLDER: {
          FIRSTNAME: 'Enter first name',
          LASTNAME: 'Enter last name',
          COMPANY_POSITION: 'Enter job title',
          EMAIL: 'Enter email address',
          GROUP: 'Select a role',
        },
        FOOTER: 'The invite might land in their spam folder. Let them know to check it if they don\'t see it in their main inbox.',
      },
      STEP_3: {
        TITLE: 'About your company',
        SUBTITLE: 'These 4 questions help us understand your company and will be used by wokap\'s AI to help you craft better job posts.',
        PLACEHOLDER: { ANSWER: 'Write your answer' },
        ENTITY_QUESTION_ONE: 'What are your main products or services?',
        ENTITY_QUESTION_TWO: 'What makes your company unique?',
        ENTITY_QUESTION_THREE: 'Who is your target audience or main customer base?',
        ENTITY_QUESTION_FOUR: 'In which regions or countries do you operate?',
        ENTITY_QUESTION_FIVE: 'How would you describe your company culture? (Optional)',
        ENTITY_QUESTION_SIX: 'Anything else we should know? (Optional)',
      },
      STEP_4: {
        TITLE: 'Upload company logo',
        TERMS_LABEL: 'I confirm I am authorized to create this account and agree to the',
        TERMS_LINK: 'Terms of Service',
        TERMS_LABEL_2: ' and the ',
        PRIVACY_LINK: 'Privacy Policy',
        PRIVACY_LABEL_2: ', including the processing of data provided by the organization, as well as access, analysis, recording and management of activity within wokap\'s SaaS — both mine and that of any user added to this account — in accordance with its policies. The organization is responsible for the users it invites and their use of the service\'s data and tools.',
        AVATAR: {
          TITLE: 'Upload logo',
          INFO: 'Recommended size: 200x200px (JPG or PNG).',
          BUTTON: 'Upload',
          REPLACE_BUTTON: 'Replace logo',
        },
      },
      STEP_5: {
        TITLE: 'Company description',
        INFO: 'We generated a description for <strong>{{name}}</strong> based on your answers. You can edit it manually or ask our AI to tweak it.',
        DESCRIPTION: 'Description',
        EDIT: 'Edit',
        SAVE: 'Save',
        UNSAVED_DESCRIPTION_WARNING: 'The description is unsaved.<br class="block sm:hidden"> Remove it or save it to continue.',
        PUBLIC_DESCRIPTION_LABEL: 'Make this description public (you can change this later in settings).',
        AI_PROMPT: {
          COMPANY_CHANGES: 'Want to make changes?',
          PLACEHOLDER: 'e.g., Make it sound more formal, highlight our core values...',
        },
        SUGGESTED_CHIPS: {
          DESCRIBE_COMPANY: 'Describe our company better',
          USE_FORMAL_LANGUAGE: 'Make it more formal',
          SHORTER_AND_DIRECT: 'Make it shorter and direct',
          PROFESSIONAL_TONE: 'Use a more professional tone',
          REMOVE_GENERICS: 'Remove generic phrases',
          EMPHASIZE_VALUES: 'Highlight our values',
          MENTION_SECTOR: 'Mention our specific industry',
          ADD_ACHIEVEMENTS: 'Add our achievements',
          RELEVANT_AT_START: 'Put the most important info first',
        },
        LOADING: {
          GENERATING_DESCRIPTION: 'Generating your company description...',
          AI_INPUT_PLACEHOLDER: 'Hold on a second...',
        },
        ERRORS: {
          GENERATION_FAILED: 'We couldn\'t generate the description. Please try again.',
          DESCRIPTION_REQUIRED: 'A description is required to finish setup.',
          DESCRIPTION_MIN_LENGTH: 'The description must be at least 10 characters long.',
        },
        RETRY: 'Try again',
      },
    },
    EDIT: {
      UNSUBSCRIBE: 'Close account',
      SUCCESS: 'Company updated successfully.',
      DELETE_SUCCESS: 'Account closed successfully.',
      DELETE_SUCCESS_REDIRECT: 'Account closed successfully. You will be redirected to the login screen.',
      CROP_IMAGE: { TITLE: 'Crop image' },
      DELETE_DIALOG: {
        HEADER: 'Are you sure you want to close your account?',
        REASON_LABEL: 'We\'re sorry to see you go. Could you tell us why?',
        REASON_REQUIRED: 'Please select a reason',
        REASONS: {
          OBJECTIVE_ACHIEVED: 'I hired someone / achieved my goal.',
          NO_VACANCY: 'I don\'t have any active jobs.',
          ANOTHER_PROVIDER: 'I switched to another platform.',
          COST: 'It\'s too expensive.',
          OTHER: 'Other',
        },
        COMMENT_LABEL: 'Feedback:',
        COMMENT_PLACEHOLDER: 'Please leave us a comment.',
        CONTACT_US: 'Want to chat before leaving?\nWe might be able to help.',
        CONTACT_EMAIL: 'Contact us',
        WHATSAPP_MESSAGE: 'Hi, I\'d like to chat before closing my account.',
        WARNING_PERMANENT: 'This action is permanent.<br>Closing your account will delete all associated data, jobs, and users.',
        CONFIRM_CHECKBOX: 'I confirm that I understand this action cannot be undone.',
        ACCEPT: 'Close account',
        REJECT: 'Cancel',
        CONFIRM_DIALOG: {
          HEADER: 'Are you completely sure?',
          MESSAGE: '🔴 Once your account is closed, <strong>there is no going back.</strong><br>You will lose all your data, jobs, and associated users forever.',
          ACCEPT: 'Close account permanently',
          REJECT: 'Cancel',
        },
      },
    },
    LIST: {
      TITLE: 'Company Management',
      FILTERS: {
        SEARCH: {
          PLACEHOLDER: 'Search company',
          SUBMIT: 'Search',
        },
        COUNTRY: 'Country',
        SECTOR: 'Industry',
        DATE: 'Date range',
        SIZE: 'Company size',
        STATUS: 'Status',
      },
      TABLE: {
        HEADER: {
          LOGO: 'Logo',
          NAME: 'Name',
          SIZE: 'Size',
          SECTOR: 'Industry',
          CITY: 'City',
          COUNTRY: 'Country',
          ENABLED: 'Enabled',
          DELETE: '',
          STATUS_ENTITY: 'Status',
          FIRST_OFFER_DATE: 'First job posted',
          LAST_ACTIVITY: 'Last activity',
          TOTAL_OFFERS: 'Total jobs',
          TOTAL_APPLY_OFFER: 'Total applications',
          AVERAGE_USERS_SUBSCRIBED: 'Avg. applicants',
          TOTAL_OFFERS_LAST_MONTH: 'Jobs (last month)',
          TOTAL_APPLY_OFFER_LAST_MONTH: 'Applications (last month)',
          AVERAGE_USERS_SUBSCRIBED_LAST_MONTH: 'Avg. applicants (last month)',
        },
        ACTIONS: { DELETE: 'Delete company' },
        NO_DATA: 'No companies found',
      },
      SUCCESS: {
        TITLE: 'Company updated.',
        TEXT: 'Company details have been successfully updated.',
      },
    },
    USERS_LIST: {
      TITLE: 'Company details',
      SEE_MORE: 'See more',
      FILTERS: {
        SEARCH: {
          PLACEHOLDER: 'Search by name or email',
          SUBMIT: 'Search',
        },
      },
      TABLE: {
        HEADER: {
          AVATAR: 'Avatar',
          NAME: 'Name',
          EMAIL: 'Email',
          LOCALE: 'Language',
          GROUP: 'Role',
          ENABLED: 'Enabled',
        },
      },
      NO_DATA: 'No users found in this company',
    },
    DISABLED: {
      TITLE: 'Thanks for signing up to wokap!',
      TAGLINE: 'You\'ll receive an email shortly with the status of your application.</br> Please check your spam folder just in case.</br> Reach out if you have any questions!',
      SUBTITLE: 'Welcome to wokap!',
      ACTIONS: {
        LOGOUT: 'Sign out',
        DASHBOARD: 'Go to dashboard',
        EXIT: 'Exit',
      },
    },
    DELETED: {
      TITLE: 'Your company has been deleted',
      SUBTITLE: 'If you think this is a mistake, please contact us at ',
      MAIL: 'saas@wokap.com',
    },
    SIZES: {
      MICRO: '1-9 employees',
      SMALL: '10-49 employees',
      MEDIUM: '50-249 employees',
      LARGE: '250+ employees',
    },
    SIZES_TABLE: {
      MICRO: '1-9',
      SMALL: '10-49',
      MEDIUM: '50-249',
      LARGE: '250+',
    },
    STATUS: {
      PARTIAL: 'Incomplete setup',
      PENDING_ACTIVATED: 'Pending activation',
      ACTIVE: 'Active',
      INACTIVE: 'Inactive',
    },
    ERRORS: {
      MEDIA_UPLOAD: 'Failed to upload image',
      INVALID_FORM: 'Please fill in all required fields',
      FILE_NOT_BLANK: 'File cannot be empty',
      FILE_MAX_SIZE: 'File size cannot exceed 50MB',
      FILE_MIME_TYPE_WRONG: 'Invalid file type',
      NAME_NOT_BLANK: 'Name is required',
      NAME_MIN_LENGTH: 'Name must be at least 3 characters',
      NAME_MAX_LENGTH: 'Name cannot exceed 255 characters',
      BUSINESS_NAME_NOT_BLANK: 'Company name is required',
      BUSINESS_NAME_MIN_LENGTH: 'Company name must be at least 3 characters',
      BUSINESS_NAME_MAX_LENGTH: 'Company name cannot exceed 255 characters',
      ADDRESS_NOT_BLANK: 'Address is required',
      ADDRESS_MIN_LENGTH: 'Address must be at least 3 characters',
      ADDRESS_MAX_LENGTH: 'Address cannot exceed 255 characters',
      CITY_NOT_BLANK: 'City is required',
      CITY_MIN_LENGTH: 'City must be at least 3 characters',
      CITY_MAX_LENGTH: 'City cannot exceed 255 characters',
      POSTAL_CODE_NOT_BLANK: 'ZIP / Postal code is required',
      POSTAL_CODE_MIN_LENGTH: 'ZIP / Postal code must be at least 3 characters',
      POSTAL_CODE_MAX_LENGTH: 'ZIP / Postal code cannot exceed 10 characters',
      STATE_NOT_BLANK: 'State is required',
      STATE_MIN_LENGTH: 'State must be at least 3 characters',
      STATE_MAX_LENGTH: 'State cannot exceed 255 characters',
      COUNTRY_NOT_BLANK: 'Country is required',
      COUNTRY_MIN_LENGTH: 'Country must be at least 1 character',
      COUNTRY_MAX_LENGTH: 'Country cannot exceed 255 characters',
      CIF_NOT_BLANK: 'Tax ID is required',
      CIF_MIN_LENGTH: 'Tax ID must be at least 3 characters',
      CIF_MAX_LENGTH: 'Tax ID cannot exceed 20 characters',
      PHONE_NOT_BLANK: 'Phone number is required',
      PHONE_MIN_LENGTH: 'Phone number must be at least 3 characters',
      PHONE_MAX_LENGTH: 'Phone number cannot exceed 20 characters',
      PHONE_INVALID: 'Invalid phone number. Please include the country code',
      EMAIL_NOT_BLANK: 'Email is required',
      EMAIL_INVALID: 'Invalid email format',
      EMAIL_ALREADY_EXISTS: 'This email is already in use',
      WEB_NOT_BLANK: 'Website is required',
      WEB_MIN_LENGTH: 'Website URL must be at least 3 characters',
      WEB_MAX_LENGTH: 'Website URL cannot exceed 255 characters',
      COMPANY_SIZE_NOT_BLANK: 'Company size is required',
      COMPANY_SIZE_MIN_LENGTH: 'Company size must be at least 1 character',
      COMPANY_SIZE_MAX_LENGTH: 'Company size cannot exceed 20 characters',
      DESCRIPTION_NOT_BLANK: 'Description is required',
      DESCRIPTION_MIN_LENGTH: 'Description must be at least 10 characters',
      LEAST_MIN_ENTITY_LOCATIONS: 'Please add at least one location',
      GREATER_MAX_ENTITY_LOCATIONS: 'You can only add up to 20 locations',
      MEDIA_ENTITY_NOT_FOUND: 'Media file not found',
      SECTOR_NOT_FOUND: 'Industry not found',
      ENTITY_NOT_FOUND: 'Company not found',
      ZIP_CODE_INVALID: 'Invalid ZIP / Postal code',
      IMAGE_MIME_TYPE_WRONG: 'Invalid image type',
      IMAGE_MAX_SIZE: 'Image size cannot exceed 10MB',
      ENTITY_LOCATION_NOT_REMOVED: 'Cannot delete this location because it is tied to an active job post',
      DUPLICATE_EMAIL: 'One or more team members have the same email address. Please ensure all emails are unique.',
      ERROR_CREATING_ENTITY_RESPONSIBLES: 'Error inviting team members. Please check that all emails are unique.',
    },
  },
  DATA_MANAGEMENT: {
    TITLE: 'Data settings',
    BREADCRUMB_TITLE: 'Configure data',
    PHONE: 'Phone & extension',
    WHATSAPP: 'WhatsApp',
    EMAIL: 'Email address',
    LOCATION: 'Location for in-person interviews',
    VIRTUAL_LINK: 'Link for virtual meetings',
    SAVE: 'Save changes',
    CANCEL: 'Cancel',
    SUCCESS: 'Settings saved successfully.',
    ERROR: 'Failed to save changes. Please try again.',
    CALENDARS_TITLE: 'Calendars',
    GOOGLE_CALENDAR_CONNECT: 'Connect Google Calendar',
    GOOGLE_CALENDAR_CONNECTING: 'Connecting...',
    GOOGLE_CALENDAR_CONNECTED: 'Google Calendar connected successfully.',
    GOOGLE_CALENDAR_CONNECTED_EMAIL: 'Connected with {{ email }}',
    GOOGLE_CALENDAR_DISCONNECT: 'Disconnect',
    GOOGLE_CALENDAR_DISCONNECTED: 'Google Calendar disconnected.',
    GOOGLE_CALENDAR_ERROR: 'Failed to connect Google Calendar.',
    OUTLOOK_CALENDAR_CONNECT: 'Connect Outlook Calendar',
    OUTLOOK_CALENDAR_CONNECTING: 'Connecting...',
    OUTLOOK_CALENDAR_CONNECTED: 'Outlook Calendar connected successfully.',
    OUTLOOK_CALENDAR_CONNECTED_EMAIL: 'Connected with {{ email }}',
    OUTLOOK_CALENDAR_DISCONNECT: 'Disconnect',
    OUTLOOK_CALENDAR_DISCONNECTED: 'Outlook Calendar disconnected.',
    OUTLOOK_CALENDAR_ERROR: 'Failed to connect Outlook Calendar.',
    CALENDAR_CONNECTED: 'Calendar connected successfully.',
    CALENDAR_ERROR: 'Failed to connect calendar.',
    ICLOUD_CALENDAR_CONNECT: 'Connect iCloud Calendar',
    ICLOUD_CALENDAR_CONNECTING: 'Connecting...',
    ICLOUD_CALENDAR_CONNECTED: 'iCloud Calendar connected successfully.',
    ICLOUD_CALENDAR_CONNECTED_EMAIL: 'Connected with {{ email }}',
    ICLOUD_CALENDAR_DISCONNECT: 'Disconnect',
    ICLOUD_CALENDAR_DISCONNECTED: 'iCloud Calendar disconnected.',
    ICLOUD_CALENDAR_ERROR: 'Failed to connect iCloud Calendar.',
    ICLOUD_CALENDAR_INSTRUCTIONS_TITLE: 'How to connect iCloud Calendar?',
    ICLOUD_CALENDAR_DIALOG_SUBTITLE: 'Connect your iCloud calendar to schedule interviews automatically.',
    ICLOUD_CALENDAR_INSTRUCTIONS_STEP1: '1. Go to appleid.apple.com and sign in.',
    ICLOUD_CALENDAR_INSTRUCTIONS_STEP2: '2. Go to "Sign-In and Security" → "App-Specific Passwords".',
    ICLOUD_CALENDAR_INSTRUCTIONS_STEP3: '3. Generate a password named "Wokap" and copy it.',
    ICLOUD_CALENDAR_INSTRUCTIONS_WARNING: '⚠️ This is NOT your regular Apple ID password.',
    ICLOUD_CALENDAR_APPLE_ID_LABEL: 'Apple ID (email)',
    ICLOUD_CALENDAR_APP_PASSWORD_LABEL: 'App-Specific Password',
    ICLOUD_CALENDAR_CONNECT_BUTTON: 'Connect',
    ICLOUD_CALENDAR_CANCEL_BUTTON: 'Cancel',
  },
} as const;
